import React from 'react';
import {
  useHasMorePost,
  usePostApiStatus,
  usePostList,
} from 'app/entity/post/postHooks';
import { Empty } from '@component-lib';
import Spinner from 'seedly-component-library/spinner-new';
import Button from 'seedly-component-library/button-new';
import PostItem from '../PostItem';
import ErrorCard from '../ErrorCard';

interface OwnProps {
  handleLoadMorePost?: () => void;
  isOwnProfile?: boolean;
  limitPost?: number;
  customEmpty?: React.ReactNode;
}

const PostList = (props: OwnProps) => {
  const {
    handleLoadMorePost,
    isOwnProfile,
    limitPost = undefined,
    customEmpty,
  } = props;

  const postList = usePostList();
  const hasMore = useHasMorePost();
  const {
    isFetching,
    isFetchingMorePosts,
    isFetchPostsError,
  } = usePostApiStatus();

  const shouldRenderLoadmore = !isFetching && hasMore && handleLoadMorePost;

  if (isFetchPostsError) {
    return <ErrorCard />;
  }

  if (isFetching) {
    return (
      <div data-testid="spinner" className="flex flex-col w-full items-center">
        <Spinner />
      </div>
    );
  }

  const postDataList = postList
    .filter((_, index) => {
      return limitPost ? index < limitPost : true;
    })
    .map(post => {
      if (!post) return null;
      return (
        <PostItem
          key={post.id}
          post={post}
          isOwnProfile={isOwnProfile}
          withComment
        />
      );
    });

  return (
    <div className="w-full">
      <div className="list">
        {postDataList.length > 0
          ? postDataList
          : customEmpty || <Empty title="No Posts Found." />}
      </div>
      {shouldRenderLoadmore && !isFetching && (
        <div className="flex item-center justify-center mt-6">
          <Button
            variant="ghost"
            onClick={handleLoadMorePost}
            isLoading={isFetchingMorePosts}
          >
            Load more discussions
          </Button>
        </div>
      )}
    </div>
  );
};

export default PostList;
